import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = ({ className = "bg-gray-900 text-white py-8" }) => {
  return (
    <footer className={className}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} EnBet Consulting UG. Alle Rechte vorbehalten.
          </p>
          <div className="mt-4 space-x-6">
            <Link to="/" className="text-gray-400 hover:text-white transition-colors">
              Startseite
            </Link>
            <Link to="/impressum" className="text-gray-400 hover:text-white transition-colors">
              Impressum
            </Link>
            <Link to="/agb" className="text-gray-400 hover:text-white transition-colors">
              AGB
            </Link>
            <Link to="/datenschutz" className="text-gray-400 hover:text-white transition-colors">
              Datenschutz
            </Link>
            <Link to="/nachhaltigkeit" className="text-gray-400 hover:text-white transition-colors">
              Nachhaltigkeit
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export const MainFooter = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          {/* Top Section: Logo and Tagline */}
          <div className="flex flex-col items-center text-center mb-12">
            <img
              src="/images/IDA_20251107_181046_0000.svg"
              alt="IDA Logo"
              className="h-6 mb-4"
              loading="lazy"
            />
            <p className="text-gray-600 text-sm max-w-md">
              Compliance ohne Kopfschmerzen
            </p>
          </div>

          {/* Navigation Grid - 4 Columns */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 max-w-5xl mx-auto mb-12">
            {/* Branchen */}
            <div className="text-center md:text-left">
              <h4 className="text-xs font-semibold text-gray-900 uppercase tracking-wider mb-4">
                Branchen
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="/#industries"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Spielhalle
                  </a>
                </li>
                <li>
                  <a
                    href="/#industries"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Wettbüro
                  </a>
                </li>
                <li>
                  <a
                    href="/#industries"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Gastronomie
                  </a>
                </li>
              </ul>
            </div>

            {/* Produkte */}
            <div className="text-center md:text-left">
              <h4 className="text-xs font-semibold text-gray-900 uppercase tracking-wider mb-4">
                Produkte
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="/#features"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Compliance
                  </a>
                </li>
                <li>
                  <a
                    href="/#features"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Zeiterfassung
                  </a>
                </li>
                <li>
                  <span className="text-sm text-gray-400 flex items-center justify-center md:justify-start gap-1.5">
                    Schulungscenter
                    <span className="text-[10px] font-medium text-teal-600 bg-teal-50 px-1.5 py-0.5 rounded">
                      Soon
                    </span>
                  </span>
                </li>
                <li>
                  <a
                    href="https://eu.idaki.de/login"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Login
                  </a>
                </li>
              </ul>
            </div>

            {/* Kontakt */}
            <div className="text-center md:text-left">
              <h4 className="text-xs font-semibold text-gray-900 uppercase tracking-wider mb-4">
                Kontakt
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="mailto:info@idaki.de"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    info@idaki.de
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+4917623943896"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    +49 176 23 94 38 96
                  </a>
                </li>
              </ul>
            </div>

            {/* Rechtliches */}
            <div className="text-center md:text-left">
              <h4 className="text-xs font-semibold text-gray-900 uppercase tracking-wider mb-4">
                Rechtliches
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/impressum"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Impressum
                  </Link>
                </li>
                <li>
                  <Link
                    to="/agb"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    AGB
                  </Link>
                </li>
                <li>
                  <Link
                    to="/datenschutz"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Datenschutz
                  </Link>
                </li>
                <li>
                  <Link
                    to="/nachhaltigkeit"
                    className="text-sm text-gray-600 hover:text-teal-700 transition-colors"
                  >
                    Nachhaltigkeit
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-8">
            {/* Made in Germany Badge */}
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <div className="flex items-center gap-1">
                <div className="w-4 h-3 flex flex-col rounded-sm overflow-hidden shadow-sm">
                  <div className="h-1 bg-black"></div>
                  <div className="h-1 bg-red-600"></div>
                  <div className="h-1 bg-yellow-400"></div>
                </div>
              </div>
              <span className="font-medium">Made & Hosted in Germany</span>
            </div>

            {/* DSGVO Badge */}
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <svg
                className="w-4 h-4 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
              <span className="font-medium">DSGVO-konform</span>
            </div>
          </div>

          {/* Subtle Gradient Divider */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent mb-8"></div>

          {/* Bottom Copyright Section */}
          <div className="text-center">
            <p className="text-xs text-gray-500">
              &copy; {new Date().getFullYear()} IDA. Alle Rechte vorbehalten.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
